// Module-level toast bridge for use outside React tree (e.g., MutationCache)
type ToastFn = (message: string, type: 'success' | 'error' | 'info') => void;
let _listener: ToastFn | null = null;

export function registerToastListener(fn: ToastFn) {
  _listener = fn;
}

export function showGlobalToast(message: string, type: 'success' | 'error' | 'info' = 'info') {
  _listener?.(message, type);
}
